var map = {
	"./editorBaseApi": [
		32
	],
	"./editorBaseApi.js": [
		32
	],
	"./editorSimpleWorker": [
		22
	],
	"./editorSimpleWorker.js": [
		22
	],
	"./editorWorker": [
		82,
		0
	],
	"./editorWorker.js": [
		82,
		0
	],
	"./editorWorkerHost": [
		43
	],
	"./editorWorkerHost.js": [
		43
	],
	"./findSectionHeaders": [
		74
	],
	"./findSectionHeaders.js": [
		74
	],
	"./getIconClasses": [
		84,
		0
	],
	"./getIconClasses.js": [
		84,
		0
	],
	"./languageFeatureDebounce": [
		95,
		0
	],
	"./languageFeatureDebounce.js": [
		95,
		0
	],
	"./languageFeatures": [
		103,
		0
	],
	"./languageFeatures.js": [
		103,
		0
	],
	"./languageFeaturesService": [
		104,
		0
	],
	"./languageFeaturesService.js": [
		104,
		0
	],
	"./languageService": [
		108,
		0
	],
	"./languageService.js": [
		108,
		0
	],
	"./languagesAssociations": [
		110,
		0
	],
	"./languagesAssociations.js": [
		110,
		0
	],
	"./languagesRegistry": [
		109,
		0
	],
	"./languagesRegistry.js": [
		109,
		0
	],
	"./markerDecorations": [
		122,
		0
	],
	"./markerDecorations.js": [
		122,
		0
	],
	"./markerDecorationsService": [
		123,
		0
	],
	"./markerDecorationsService.js": [
		123,
		0
	],
	"./model": [
		141,
		0
	],
	"./model.js": [
		141,
		0
	],
	"./modelService": [
		143,
		0
	],
	"./modelService.js": [
		143,
		0
	],
	"./resolverService": [
		204,
		0
	],
	"./resolverService.js": [
		204,
		0
	],
	"./semanticTokensDto": [
		205,
		0
	],
	"./semanticTokensDto.js": [
		205,
		0
	],
	"./semanticTokensProviderStyling": [
		206,
		0
	],
	"./semanticTokensProviderStyling.js": [
		206,
		0
	],
	"./semanticTokensStyling": [
		208,
		0
	],
	"./semanticTokensStyling.js": [
		208,
		0
	],
	"./semanticTokensStylingService": [
		209,
		0
	],
	"./semanticTokensStylingService.js": [
		209,
		0
	],
	"./textModelSync/textModelSync.impl": [
		76
	],
	"./textModelSync/textModelSync.impl.js": [
		76
	],
	"./textModelSync/textModelSync.protocol": [
		210,
		0
	],
	"./textModelSync/textModelSync.protocol.js": [
		210,
		0
	],
	"./textResourceConfiguration": [
		203,
		0
	],
	"./textResourceConfiguration.js": [
		203,
		0
	],
	"./treeSitterParserService": [
		197,
		0
	],
	"./treeSitterParserService.js": [
		197,
		0
	],
	"./treeViewsDnd": [
		211,
		0
	],
	"./treeViewsDnd.js": [
		211,
		0
	],
	"./treeViewsDndService": [
		212,
		0
	],
	"./treeViewsDndService.js": [
		212,
		0
	],
	"./unicodeTextModelHighlighter": [
		44
	],
	"./unicodeTextModelHighlighter.js": [
		44
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75;
module.exports = webpackAsyncContext;